export const PRODUCT_FETCH_SUCCESS = 'PRODUCT_FETCH_SUCCESS';
export const PRODUCT_FETCH_FAILURE = 'PRODUCT_FETCH_FAILURE';

export const CATEGORIES_FETCH_SUCCESS = 'CATEGORIES_FETCH_SUCCESS';
export const CATEGORIES_FETCH_FAILURE = 'CATEGORIES_FETCH_FAILURE';

export const FILTER_PRODUCTS = 'FILTER_PRODUCTS';

export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_FAILURE = 'ADD_TO_CART_FAILURE';

export const REMOVE_FROM_CART_SUCCESS = 'REMOVE_FROM_CART_SUCCESS';
export const REMOVE_FROM_CART_FAILURE = 'REMOVE_FROM_CART_FAILURE';

export const CART_DETAILS_FETCH_SUCCESS = 'CART_DETAILS_FETCH_SUCCESS';
export const CART_DETAILS_FETCH_FAILURE = 'CART_DETAILS_FETCH_FAILURE';

export const CLEAR_CART = 'CLEAR_CART';

export const CART_DETAILS_UPDATE_SUCCESS = 'CART_DETAILS_UPDATE_SUCCESS';
export const CART_DETAILS_UPDATE_FAILURE = 'CART_DETAILS_UPDATE_FAILURE';